<template>
  <inventoryProductsSubCategoriesForm :typeEndPoint="'inventoryProductsSubCategoriesForm'" :dataParams="{}" />
</template>
<script>
import inventoryProductsSubCategoriesForm from '@/components/modules/inventory/products/subcategories/form'
export default {
  name: 'inventoryProductsSubCategories',
  components: {
    inventoryProductsSubCategoriesForm
  },
  mounted () {
    console.log(this.$route.params)
  }
}

</script>



// WEBPACK FOOTER //
// src/views/inventory/products/subcategories/create.vue